import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure and report web vitals (performance metrics)
// To log results, pass a function: reportWebVitals(console.log)
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
